<ng-container *transloco="let t">
  <div class="cpv-ccv-finding" [formGroup]="form">
    <div class="field">
      <label class="label">{{ t('cpvccv.cpv') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="cpv" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('cpvccv.ccv') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="ccv" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('cpvccv.note') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="note" rows="3"></textarea>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
